// extracted by mini-css-extract-plugin
module.exports = {"divider":"style-module__divider___1kukr"};